import React from "react";
import styled from "styled-components";
import theme from "../../styles/theme";

const Discount = styled.div`
  padding: 8px;
  border-radius: 4px;
  width: 400px;

  background: #2e2a2a;
  background: linear-gradient(
    90deg,
    rgba(46, 42, 42, 1) 0%,
    rgba(9, 9, 121, 1) 46%,
    rgba(12, 100, 117, 1) 100%
  );
`;

const DiscountTitle = styled.div`
  color: ${theme.colors.green};
  font-weight: 500;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const DiscountValueContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 150px;
  color: ${theme.colors.green};
  flex: 1;
`;

const DiscountValue = styled.div`
  font-size: 48px;
  line-height: 38px;
  font-weight: bold;
`;

const DiscountCode = styled.div`
  align-self: center;
  height: 48px;
  color: #19ff00;
  flex: 1;
  border: 2px solid rgb(255 255 255 / 10%);
  font-size: 24px;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  max-width: 200px;
  cursor: pointer;

  filter: blur(5px);

  &:hover {
    filter: blur(0);
  }
`;

const UsedOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(1px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-radius: inherit;
`;

const UsedStamp = styled.span`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 24px;
  color: #ff4d4f;
  border: 3px solid #ff4d4f;
  padding: 4px 12px;
  transform: rotate(-15deg);
  border-radius: 4px;
  user-select: none;
`;

const Voucher = ({ id, title, discount, code, description, expires, used }) => {
  return (
    <Discount key={id} style={{ position: "relative", overflow: "hidden" }}>
      {used && (
        <UsedOverlay>
          <UsedStamp>Використано</UsedStamp>
        </UsedOverlay>
      )}

      <div style={{ opacity: used ? 0.5 : 1 }}>
        <DiscountTitle>{title}</DiscountTitle>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
          {discount.type === "percentage" && (
            <DiscountValueContainer>
              <DiscountValue>-{discount.value}% </DiscountValue>
              <div>знижка</div>
            </DiscountValueContainer>
          )}
          {discount.type === "pass" && (
            <DiscountValueContainer>
              <div>Ticket</div>
            </DiscountValueContainer>
          )}
          <DiscountCode>{code}</DiscountCode>
        </div>

        <div
          style={{ display: "flex", fontSize: 12, justifyContent: "flex-end", textAlign: "end" }}
        >
          {description}
        </div>
        <div style={{ display: "flex", fontSize: 12, justifyContent: "flex-end" }}>
          Дійсний до{" "}
          {new Date(expires).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
          })}
        </div>
      </div>
    </Discount>
  );
};

export default Voucher;
